import ScrollReveal from '@/components/ScrollReveal';
import GoogleFormTabs from '@/components/GoogleFormTabs';
import { useLanguage } from '@/lib/i18n';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export default function Requests() {
  const { t } = useLanguage();

  const faqs = [
    { q: t('requests_faq1_q'), a: t('requests_faq1_a') },
    { q: t('requests_faq2_q'), a: t('requests_faq2_a') },
    { q: t('requests_faq3_q'), a: t('requests_faq3_a') },
  ];

  return (
    <main id="main-content" className="pt-32 pb-24" data-testid="requests-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <ScrollReveal>
          <span
            className="
    font-mono
    text-[10px]
    uppercase
    tracking-[0.3em]
    mb-4
    bg-gradient-to-r
    from-[#856ae7]
    to-[#ffffff]
    bg-clip-text
    text-transparent
  "
          >
            {t("request_project")}
          </span>
          <h1 className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-4" data-testid="requests-page-title">
            {t('requests_title')}
          </h1>
          <p className="text-white/35 text-lg mb-16 max-w-xl" data-testid="requests-page-subtitle">
            {t('requests_subtitle')}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <GoogleFormTabs />
        </ScrollReveal>

        {/* FAQ Section */}
        <ScrollReveal delay={0.2}>
          <div className="mt-24 max-w-2xl" data-testid="requests-faq">
            <h2 className="font-syne text-2xl font-bold mb-8">{t('requests_faq_title')}</h2>
            <Accordion type="single" collapsible>
              {faqs.map((faq, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-white/[0.06]">
                  <AccordionTrigger
                    className="text-left text-white/70 hover:text-white text-sm"
                    data-testid={`faq-trigger-${i}`}
                  >
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-white/35 text-sm leading-relaxed">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </ScrollReveal>
      </div>
    </main>
  );
}
